export default "__VITE_ASSET__CkWQ0ZrM__"